/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Chargement"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var frFR = Object.assign(TranslationProviderComponent, {
  translations
});

export { frFR as f };
//# sourceMappingURL=fr-FR-DSFwtiWH.js.map
